import { render, staticRenderFns } from "./medias.vue?vue&type=template&id=90674786"
import script from "./medias.vue?vue&type=script&lang=js"
export * from "./medias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports